import React, { useState, useEffect } from "react";
import store from "store";
import { imageMediaUrl } from "util/config";
import "./index.css";

const menuItems = [
  { label: "Home", route: "/trainee", icon: "BookOpen.png" },
  { label: "My Courses",  route: "/trainee-courses", icon: "Graduation-cap.png" },
  { label: "Track Progress",  route: "/trainee-progress", icon: "graph-bar-increase.png" },
  { label: "Leaderboard",  route: "/trainee-leaderboard", icon: "Trophy.png" },
  { label: "Schedule",  route: "/trainee-schedule", icon: "calender.png" },
];

const SideNavbar = (props) => {
  const [selected, setSelected] = useState(
    localStorage.getItem("selectedMenu") || "Home"
  );
  const { location } = props;
  console.log(location,'location')

  var userInfo = store.get("user");

  console.log(userInfo,'userInfo.organisation',store.get("accessToken"))

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  useEffect(() => {
    const stored = localStorage.getItem("selectedMenu");
    if (stored && stored !== selected) setSelected(stored);
  }, []);
  const handleMenuClick = (label) => {
    setSelected(label);
    setIsSidebarOpen(false);
    localStorage.setItem("selectedMenu", label);

    switch (label) {
      case "Home":
        window.location.href = "/trainee";
        break;
      case "My Courses":
        window.location.href = "/trainee-courses";
        break;
      case "Track Progress":
        window.location.href = "/trainee-progress";
        break;
      case "Leaderboard":
        window.location.href = "/trainee-leaderboard";
        break;
      case "Schedule":
        window.location.href = "/trainee-schedule";
        break;

      default:
        break;
    }
  };
  return (
    <>
      <button
        className="sidebar-toggle"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        ☰
      </button>

      <div className={`side-navbar ${isSidebarOpen ? "open" : ""}`}>
        <div className="profile-section">
          <img
           src={
            userInfo.profilePhoto && userInfo.profilePhoto !== ""
              ? `${imageMediaUrl}${userInfo.profilePhoto}?token=${store.get("accessToken")}`
              : require("assets/images/avatures/avature-2.png")
          }
          alt=""
          className="uk-border-circle" style={{width:"120px",height:"120px"}}
          />
        </div>

        <ul className="menu">
          {menuItems.map((item) => {
            if((item.label == "Leaderboard" && !userInfo.organisationId.showLeaderBoard) || (item.label == "Track Progress" && userInfo.organisationId.hideTrackProgress))
              return false;
            return(<li
              key={item.label}
              className={`menu-item ${
                item.route === location.pathname ? "selected" : ""
              }`}
              onClick={() => handleMenuClick(item.label)}
            >
              <img
                className={`icon-image ${
                  item.route === location.pathname ? "selected" : ""
                }`}
                src={`/assets/${
                  item.route === location.pathname
                    ? item.icon.replace(".png", "_dark.png")
                    : item.icon
                }`}
                alt={item.label}
              />
              <span className="label">{item.label}</span>
            </li>)
        })}
        </ul>
      </div>
    </>
  );
};

export default SideNavbar;
